import { OptionGroup } from "@/types";
import { atom } from "jotai";

const optionGroupsAtom = atom<OptionGroup[]>([])

export default optionGroupsAtom
